// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__ma_Hy","center":"Container_center__ssxyF","load":"Container_load__giqL5"};